<template>

    <q-input
        class="mw-form-v2-input"
        :filled="settings.theme.input.filled"
      :outlined="settings.theme.input.outlined"
      :standout="settings.theme.input.standout"
      :borderless="settings.theme.input.borderless"
      :rounded="settings.theme.input.rounded"
      :square="settings.theme.input.square"
      :dense="settings.theme.input.dense"
        v-model="fieldValue"
        :label="field.layout_injected_label ? field.layout_injected_label : field.label"
        mask="###-###-####"
        unmasked-value

        :rules="field.required  ? [

            val => !!val || requiredText,
            val => val.length > 9 || 'Please use minimum 10 digits',
            val => isValidUsPhone() || 'Please type valid us phone number'

            ] : []">
      <template v-slot:append>
        <q-icon name="s_phone" />
      </template>
       <template v-slot:label>
         {{field.layout_injected_label ? field.layout_injected_label : field.label}}
      <OptionalLabel :field="field"></OptionalLabel>
      </template>
    </q-input>

</template>

<script>
import libphonenumber from "google-libphonenumber";
import {mapFields} from "vuex-map-fields";
import OptionalLabel from "@/components/OptionalLabel";
export default {
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {

    };
  },
  components: {OptionalLabel},
  emits: ['update:modelValue'],
  methods: {
    isValidUsPhone() {
      try {
        if(this.fieldValue.length < 10) {
          return false;
        }
        const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
        const phone = phoneUtil.parse(this.fieldValue, 'US');

        const region = phoneUtil.getRegionCodeForNumber(phone);

        return region === 'US' || region === 'PR';
      } catch (e) {
        return false
      }

    }
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please type phone number';
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {

  }
}
</script>
